// extracted by mini-css-extract-plugin
export var infoItem = "_qy-2";
export var title = "_qy-0";
export var value = "_qy-1";